module.exports = __webpack_public_path__ + "img/discover.fcc5b544.png";